(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-control-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxe-app-control')) {
    customElements.define('luxe-app-control', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-app-slide]')];
        this.dots = [...this.querySelectorAll('[data-app-dot]')];
        if (!this.slides.length) return;

        this.showSlide = (index) => {
          const nextIndex = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === nextIndex;
            slide.hidden = !active;
            slide.classList.toggle('is-active', active);
          });
          this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === nextIndex ? 'true' : 'false'));
          this.index = nextIndex;
        };

        this.index = 0;
        this.querySelector('[data-app-previous]')?.addEventListener('click', () => this.showSlide(this.index - 1));
        this.querySelector('[data-app-next]')?.addEventListener('click', () => this.showSlide(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.showSlide(Number(dot.dataset.appIndex))));

        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-app-slide]');
          if (slide) this.showSlide(Number(slide.dataset.appIndex));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beautiful-day-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxe-image-compare')) {
    customElements.define('luxe-image-compare', class extends HTMLElement {
      connectedCallback() {
        const input = this.querySelector('input[type="range"]');
        if (!input) return;

        const update = () => {
          const position = `${input.value}%`;
          this.style.setProperty('--comparison-position', position);
          input.setAttribute('aria-valuetext', `${input.value}% day, ${100 - Number(input.value)}% night`);
        };

        input.addEventListener('input', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["day-night-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('day-night-compare')) {
    customElements.define('day-night-compare', class extends HTMLElement {
      connectedCallback() {
        const input = this.querySelector('input');
        if (!input) return;
        input.addEventListener('input', () => this.style.setProperty('--position', `${input.value}%`));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["endless-possibilities"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxe-possibilities')) {
    customElements.define('luxe-possibilities', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-possibility-tab]')];
        this.panels = [...this.querySelectorAll('[data-possibility-panel]')];
        if (!this.tabs.length || !this.panels.length) return;

        this.style.setProperty('--scene-count', this.tabs.length);
        this.frameDuration = Number(this.dataset.frameDuration) || 180;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.isVisible = true;

        this.stopAnimation = () => {
          window.clearInterval(this.animationTimer);
          this.animationTimer = null;
        };

        this.showFrame = (panel, index) => {
          const frames = [...panel.querySelectorAll('[data-possibility-frame]')];
          if (!frames.length) return;
          const nextIndex = (index + frames.length) % frames.length;
          frames.forEach((frame, frameIndex) => frame.classList.toggle('is-active', frameIndex === nextIndex));
          panel.dataset.activeFrame = String(nextIndex);
        };

        this.startAnimation = () => {
          this.stopAnimation();
          const panel = this.panels[this.index];
          if (!panel) return;
          const frames = [...panel.querySelectorAll('[data-possibility-frame]')];
          this.showFrame(panel, 0);
          if (frames.length < 2 || this.motionPreference.matches || !this.isVisible || document.hidden) return;
          this.animationTimer = window.setInterval(() => {
            const currentFrame = Number(panel.dataset.activeFrame) || 0;
            this.showFrame(panel, currentFrame + 1);
          }, this.frameDuration);
        };

        this.showScene = (index, moveFocus = false) => {
          const nextIndex = (index + this.tabs.length) % this.tabs.length;
          this.tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === nextIndex;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel, panelIndex) => {
            const active = panelIndex === nextIndex;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          });
          if (moveFocus) this.tabs[nextIndex].focus();
          this.index = nextIndex;
          this.startAnimation();
        };

        const currentTab = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        this.index = currentTab >= 0 ? currentTab : 0;
        this.startAnimation();

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.showScene(Number(tab.dataset.possibilityIndex)));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = this.index;
            if (event.key === 'ArrowLeft') nextIndex -= 1;
            if (event.key === 'ArrowRight') nextIndex += 1;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = this.tabs.length - 1;
            this.showScene(nextIndex, true);
          });
        });

        this.addEventListener('shopify:block:select', (event) => {
          const panel = event.target.closest('[data-possibility-panel]');
          if (panel) this.showScene(Number(panel.dataset.possibilityIndex));
        });

        this.handleVisibility = () => {
          if (document.hidden) this.stopAnimation();
          else this.startAnimation();
        };
        document.addEventListener('visibilitychange', this.handleVisibility);

        this.handleMotionPreference = () => this.startAnimation();
        this.motionPreference.addEventListener('change', this.handleMotionPreference);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.isVisible = entries[0]?.isIntersecting ?? true;
            if (this.isVisible) this.startAnimation();
            else this.stopAnimation();
          }, { threshold: 0.08 });
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        this.stopAnimation?.();
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.handleVisibility);
        this.motionPreference?.removeEventListener('change', this.handleMotionPreference);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.luxeGalleryLightboxBound) {
    window.luxeGalleryLightboxBound = true;
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-gallery-open]');
      if (opener) {
        const dialog = document.getElementById(opener.getAttribute('aria-controls'));
        if (dialog) dialog.showModal();
      }
      const closer = event.target.closest('[data-gallery-close]');
      if (closer) closer.closest('dialog').close();
    });
    document.addEventListener('click', (event) => {
      if (event.target.matches('.gallery-lightbox')) event.target.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occasion-scenes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luxe-scene-selector')) {
    customElements.define('luxe-scene-selector', class extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('[data-scene-button]')];
        if (!this.buttons.length) return;

        this.activate = (button) => {
          this.buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        };

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.activate(button));
          button.addEventListener('focus', () => this.activate(button));
          button.addEventListener('pointerenter', () => {
            if (window.matchMedia('(hover: hover) and (min-width: 750px)').matches) this.activate(button);
          });
        });

        this.addEventListener('shopify:block:select', (event) => {
          const button = event.target.closest('[data-scene-button]');
          if (button) this.activate(button);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-page-hero"] && !Shopify.designMode) return;
  try {
    
  if (!document.querySelector('[data-luxe-lead-form-script]')) {
    const leadFormScript = document.createElement('script');
    leadFormScript.src = 'https://links.luxehomeconcepts.com/js/form_embed.js';
    leadFormScript.defer = true;
    leadFormScript.dataset.luxeLeadFormScript = '';
    document.head.appendChild(leadFormScript);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reach-out"]) return;
  try {
    
  if (!customElements.get('reach-out-assist')) {
    customElements.define('reach-out-assist', class extends HTMLElement {
      connectedCallback() {
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('.reach-out__trigger');
        const close = this.querySelector('.reach-out__close');
        if (!dialog || !trigger || !close) return;
        trigger.addEventListener('click', () => dialog.showModal());
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
